import entries from "@Object/entries";
import useCurrency from "@Currency/hooks/useCurrency";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassPriceVariationsProps {
    passengerClass: AvailablePassengerClassType,
}

function PassengerClassPriceVariations({passengerClass}: PassengerClassPriceVariationsProps) {
    const {val} = useCurrency()

    return (
        <ul>
            Price per person is variable for this service:
            {entries(passengerClass.prices).map(([users, price]) => (
                <li key={`${passengerClass.id}-${users}`}>
                    {`${users} person: ${price}${val}`}
                </li>
            ))}
        </ul>
    )
}

export default PassengerClassPriceVariations